const Animations = () => {

    return (

        <div className="clouds">
          <div className="cloud"></div>
          <div className="cloud a"></div>
          <div className="cloud b"></div>
          <div className="cloud c"></div>
          <div className="cloud d"></div>
      </div>
    )
}

export default Animations;